import script from "./SettingsMixin.vue?vue&type=script&lang=js"
export * from "./SettingsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__